import CardViewPublic from 'pages/manage/events/manage/CardViewPublic';
import React from 'react'
import { fetchGraphQL } from 'services/graphql/GraphQL';


export default class MoreEventsByCheckoutPage extends React.Component<{ [label: string]: any }, { [label: string]: any }> {

    constructor(props) {
        super(props)
        this.state = {
            activeEvents: [],
            inactiveEvents: [],
            loading: true,
            hostname: '',
            events: []
        }
    }

    public componentDidMount() {
        const userId = this.props.userId
        const hostname = this.props.hostname
        fetchGraphQL(
            `
            {
              event {
                getByUserId(userId:"${userId}") {
                  id
                  name
                  location
                  isActive,
                  currency
                  onSale
                  styling {promoImg}
                  promoters
                  checkers
                  payoutTime
                  createdBy
                  urlHash
                  timeObject {
                    startYear
			        startMonth
			        startDay
			        startHour
			        startMinutes
                    startAMPM
                    endYear
                    endMonth
                    endDay
                    endHour
                    endMinutes
                    endAMPM
                  }
                }
              }
            }
          `,
            undefined
        ).then(result => {

            if (result) {

                const sortedEvents = result.event.getByUserId.sort((s, e) => {
                    const startTime = new Date(s.timeObject.startYear, s.timeObject.startMonth - 1, s.timeObject.startDay, s.timeObject.startAMPM ? s.timeObject.startHour + 12 : s.timeObject.startHour, s.timeObject.startMinutes)
                    const endTime = new Date(e.timeObject.startYear, e.timeObject.startMonth - 1, e.timeObject.startDay, e.timeObject.startAMPM ? e.timeObject.startHour + 12 : e.timeObject.startHour, e.timeObject.startMinutes)
                    if (startTime < endTime) { return 1 } else if (startTime > endTime) { return -1 } else { return 0 }
                })

                const inactiveEvents = sortedEvents.filter((item) => {
                    return !item.isActive;
                })

                const activeEvents = sortedEvents.filter((item) => {
                    return item.isActive;
                })

                this.setState({ loading: false, activeEvents: activeEvents.reverse(), inactiveEvents: inactiveEvents.reverse(), hostname, events: sortedEvents })
            }
        });
    }

    public render() {

        const { loading, activeEvents, inactiveEvents, events } = this.state;
        if (loading) {
            return null;
        }

        return <div className='container'>
            <h3 style={{ textAlign: 'center', width: '100%', paddingTop: '10px', paddingBottom: '10px' }}>
                More upcoming events by {this.props.hostname}
            </h3>
            <CardViewPublic events={events} inactiveEvents={inactiveEvents} activeEvents={activeEvents} insideCheckoutPage={true} />
        </div>
    }

}


// WEBPACK FOOTER //
// ./src/pages/event/public/components/MoreEventsByCheckoutPage.tsx